// src/component/routes/ProtectedRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import AuthUtils from '../utils/auth.utils';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isSessionValid = AuthUtils.isSessionValid();

  if (!isSessionValid) {
    // Clear any remaining session data
    AuthUtils.clearSession();
    // Redirect to login
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;